<template>
  <v-layout fluid row wrap>
    <v-container fluid>
      <v-layout row wrap justify-center mb-1>
        <v-btn slot="activator" @click="$router.push('/eventi/calendario')" class="btnDefault" small color="primary white--text" dark>
          <v-icon small class="mr-1">date_range</v-icon>Calendario
        </v-btn>
        <v-btn slot="activator" @click="$router.push('/eventi/classificagenerale')" class="btnDefault" small color="primary white--text" dark>
          <v-icon small class="mr-1">date_range</v-icon>Classifica Generale
        </v-btn>
        <v-btn slot="activator" v-if="isAdmin" @click="dialogCalcolaOpen()" class="btnDefault" small color="green white--text" dark>
          <v-icon small class="mr-1">refresh</v-icon>Ricalcola Ranking List
        </v-btn>

        <v-btn slot="activator" @click="dialogExportOpen()" class="btnDefault" small color="accent white--text" dark>
          <v-icon small class="mr-1">cloud_download</v-icon>Esporta Ranking List
        </v-btn>
      </v-layout>

      <v-layout row wrap justify-left>
        <v-flex hidden-md-and-down xs5></v-flex>
        <v-flex grow text-xs-center>
          <v-layout fluid row wrap justify-left>
            <v-flex md1 class="px-1 text-xs-right mt-2 pa-0">
              <v-select v-model="selezioneAnnoSportivo" :items="anniSportivi" box item-text="Descrizione" label="Anno Sportivo" return-object hide-details></v-select>
            </v-flex>
            <v-flex md1 class="px-1 text-xs-right mt-2 pa-0">
              <v-select v-model="selezioneTipo" :items="tipoClassifica" box label="Indoor/Outdoor" hide-details></v-select>
            </v-flex>
            <v-flex md2 class="px-1 text-xs-right mt-2">
              <v-autocomplete
                v-model="filtroClasse"
                :items="classi"
                style="width: auto;"
                box
                clearable
                item-text="Descrizione"
                label="Classe"
                return-object
                hide-details
              ></v-autocomplete>
            </v-flex>
            <v-flex md2 class="px-1 text-xs-right mt-2">
              <v-autocomplete
                v-model="filtroCategoria"
                :items="categorie"
                style="width: auto;"
                item-text="Descrizione"
                box
                clearable
                label="Categoria"
                return-object
                hide-details
              ></v-autocomplete>
            </v-flex>
            <v-flex md3 class="px-1 text-xs-right mt-2">
              <v-autocomplete
                v-model="filtroSezione"
                :items="sezioni"
                item-value="id"
                item-text="Descrizione"
                box
                label="Regione"
                clearable
                return-object
                hide-details
              ></v-autocomplete>
            </v-flex>
            <v-flex md1 class="px-1 text-xs-right mt-2" style="width: 150px;">
              <v-text-field v-model="filtroNumeroTessera" box label="N° Pass" mask="#########" clearable hide-details></v-text-field>
            </v-flex>
            <v-flex md2 text-xs-center>
              <v-btn slot="activator" @click="refreshList()" class="btnDefault" small color="primary white--text" dark>
                <v-icon small class="mr-1">cached</v-icon>Applica Filtro
              </v-btn>
              <v-btn slot="activator" @click="annullaFiltro()" class="btnDefault" small color="red white--text" dark>
                <v-icon small class="mr-1">delete</v-icon>Annulla Filtro
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout justify-center style="width:320px, margin:auto">
        <v-flex md3 class="px-1 text-xs-right mt-2" style="width: 320px;">
          <v-text-field v-model="filtraTesto" box label="Cerca nei risultati filtrati" clearable hide-details></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout column>
        <div class="elevation-1 mt-3 bb-3">
          <v-toolbar flat color="white">
            <v-toolbar-title>Gare valide per la ranking - {{ filtroTipo }}</v-toolbar-title>
          </v-toolbar>
          <v-toolbar flat color="white">
            <h4>Anno Sportivo: {{ filtroAnnoSportivo.Descrizione }}</h4>
          </v-toolbar>
          <v-data-table
            v-model="selected"
            :headers="filtroTipo == 'Outdoor' ? headersOutdoor : headersIndoor"
            :items="rankingGenerale"
            :search="filtraTesto"
            :pagination.sync="pagination"
            :hide-headers="isMobile"
            :class="{ mobile: isMobile }"
            disable-initial-sort
            class="subheading"
          >
            <template slot="items" slot-scope="props">
              <tr v-if="!isMobile" :style="{ color: props.item.PosizioneRanking < 4 ? getColorCategoria(props.item.categoriaCodice) : 'black' }">
                <td class="text-xs-center">{{ props.item.Classe }}</td>
                <td class="text-xs-center">{{ props.item.categoriaCodice }}</td>
                <td :class="{ 'font-weight-bold': props.item.PosizioneRanking < 4 }" class="text-xs-right">
                  <v-avatar v-if="props.item.isClassificato" :color="props.item.PosizioneRanking < 4 ? getColorCategoria(props.item.categoriaCodice) : 'grey'" size="24" small>
                    <span class="white--text xm">{{ props.item.PosizioneRanking }}</span>
                  </v-avatar>
                  <div v-else>{{ props.item.PosizioneRanking }}</div>
                </td>
                <td class="text-xs-left">{{ props.item.IscrittoDenominazione }}</td>
                <td class="text-xs-center">{{ props.item.IscrittoNumeroTessera }}</td>
                <td class="text-xs-left">{{ props.item.IscrittoAssociazione }}</td>
                <td class="text-xs-left">{{ props.item.sezioneDescrizione }}</td>
                <td class="text-xs-right">{{ props.item.PunteggioRanking }}</td>
                <td class="text-xs-right">{{ props.item.SpotRanking }}</td>
                <td class="text-xs-center">
                  <tr>
                    <div w130px>
                      <div style="float: left;" class="text-xs-right w30px pa-0">
                        {{ (props.item.punteggioGara_1 = !props.item.punteggioGara_1 ? '0' : props.item.punteggioGara_1) }}
                      </div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_1 = !props.item.spotGara_1 ? '0' : props.item.spotGara_1) }}</div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">
                        {{ (props.item.superSpotGara_1 = !props.item.superSpotGara_1 ? '0' : props.item.superSpotGara_1) }}
                      </div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.perfectGara_1 = !props.item.perfectGara_1 ? '0' : props.item.perfectGara_1) }}</div>
                    </div>
                  </tr>
                </td>

                <td class="text-xs-right">
                  <tr>
                    <div w130px>
                      <div style="float: left;" class="text-xs-right w30px pa-0">
                        {{ (props.item.punteggioGara_2 = !props.item.punteggioGara_2 ? '0' : props.item.punteggioGara_2) }}
                      </div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_2 = !props.item.spotGara_2 ? '0' : props.item.spotGara_2) }}</div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">
                        {{ (props.item.superSpotGara_2 = !props.item.superSpotGara_2 ? '0' : props.item.superSpotGara_2) }}
                      </div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.perfectGara_2 = !props.item.perfectGara_2 ? '0' : props.item.perfectGara_2) }}</div>
                    </div>
                  </tr>
                </td>

                <td v-if="filtroTipo == 'Outdoor'" class="text-xs-right">
                  <tr>
                    <div w130px>
                      <div style="float: left;" class="text-xs-right w30px pa-0">
                        {{ (props.item.punteggioGara_3 = !props.item.punteggioGara_3 ? '0' : props.item.punteggioGara_3) }}
                      </div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_3 = !props.item.spotGara_3 ? '0' : props.item.spotGara_3) }}</div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">
                        {{ (props.item.superSpotGara_3 = !props.item.superSpotGara_3 ? '0' : props.item.superSpotGara_3) }}
                      </div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.perfectGara_3 = !props.item.perfectGara_3 ? '0' : props.item.perfectGara_3) }}</div>
                    </div>
                  </tr>
                </td>

                <td v-if="filtroTipo == 'Outdoor'" class="text-xs-right">
                  <tr>
                    <div w130px>
                      <div style="float: left;" class="text-xs-right w30px pa-0">
                        {{ (props.item.punteggioGara_4 = !props.item.punteggioGara_4 ? '0' : props.item.punteggioGara_4) }}
                      </div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_4 = !props.item.spotGara_4 ? '0' : props.item.spotGara_4) }}</div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">
                        {{ (props.item.superSpotGara_4 = !props.item.superSpotGara_4 ? '0' : props.item.superSpotGara_4) }}
                      </div>
                      <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.perfectGara_4 = !props.item.perfectGara_4 ? '0' : props.item.perfectGara_4) }}</div>
                    </div>
                  </tr>
                </td>
              </tr>
              <tr
                v-else
                :active="props.selected"
                :style="{ color: props.item.PosizioneRanking < 4 ? getColorCategoria(props.item.categoriaCodice) : 'black' }"
                @click="props.selected = !props.selected"
              >
                <td class="flex-td">
                  <ul class="flex-content" ma-10>
                    <li class="text-sm-center font-weight-bold flex-item" data-label="Classe">{{ props.item.Classe }}</li>
                    <li class="text-sm-center font-weight-bold flex-item" data-label="Categoria">{{ props.item.categoriaCodice }}</li>
                    <li class="text-sm-center font-weight-bold flex-item" data-label="Posizione">{{ props.item.PosizioneRanking }}</li>
                    <li class="text-sm-center font-weight-bold flex-item" data-label="Arciere">{{ props.item.IscrittoDenominazione }}</li>
                    <li class="text-sm-center font-weight-bold flex-item" data-label="Numero Pass">{{ props.item.IscrittoNumeroTessera }}</li>
                    <li class="text-sm-center font-weight-bold flex-item" data-label="Sodalizio Arciere">{{ props.item.IscrittoAssociazione }}</li>
                    <li class="text-sm-center font-weight-bold flex-item" data-label="Regione">{{ props.item.sezioneDescrizione }}</li>
                    <li class="text-sm-center font-weight-bold" data-label="Punteggio">{{ props.item.PunteggioRanking }}</li>
                    <li class="text-sm-center font-weight-bold flex-item" data-label="Spot">{{ props.item.SpotRanking }}</li>
                    <li :data-label="filtroTipo == 'Outdoor' ? '40 Round' : '3DRound'" class="text-sm-center font-weight-bold flex-item">
                      {{ (props.item.punteggioGara_1 = !props.item.punteggioGara_1 ? ' 0 ' : props.item.punteggioGara_1) }}
                    </li>

                    <li :data-label="filtroTipo == 'Outdoor' ? '60 Target' : 'Trophy'" class="text-sm-center font-weight-bold flex-item">
                      {{ (props.item.punteggioGara_2 = !props.item.punteggioGara_2 ? ' 0 ' : props.item.punteggioGara_2) }}
                    </li>
                    <li v-if="filtroTipo == 'Outdoor'" class="text-sm-center font-weight-bold flex-item" data-label="44 Fusion">
                      {{ (props.item.punteggioGara_3 = !props.item.punteggioGara_3 ? ' 0 ' : props.item.punteggioGara_3) }}
                    </li>
                    <li v-if="filtroTipo == 'Outdoor'" class="text-sm-center font-weight-bold flex-item" data-label="60 Track">
                      {{ (props.item.punteggioGara_4 = !props.item.punteggioGara_4 ? ' 0 ' : props.item.punteggioGara_4) }}
                    </li>
                  </ul>
                </td>
              </tr>
            </template>
            <template slot="no-results">
              <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
            </template>
            <template slot="no-data">
              <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
            </template>
            <!-- PAGINAZIONE IN TABELLA  -->
            <template slot="pageText" slot-scope="props">Risultati {{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
          </v-data-table>
        </div>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialogExport" persistent max-width="490">
      <v-card>
        <v-card-title class="display-1 font-weight-bold accent white--text">Esportazione Ranking List</v-card-title>
        <v-card-text class="headline"
          >Verrà esportata la ranking list {{ filtroTipo }} dell'anno sportivo {{ filtroAnnoSportivo.Descrizione }} in formato Excel con il filtro selezionato</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogExport = false" color="red white--text" class="btnDefault" flat small> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="exportRankingGenerale()" color="accent white--text" dark> <v-icon small left>import_export</v-icon>Esporta </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCalcola" persistent max-width="490">
      <v-card>
        <v-card-title class="display-1 font-weight-bold green white--text">Calcolo Ranking List</v-card-title>
        <v-card-text class="headline">Verrà ricalcolata la ranking list per l'anno sportivo {{ filtroAnnoSportivo.Descrizione }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogCalcola = false" color="red white--text" class="btnDefault" flat small> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="calcolaRankingGenerale()" color="green white--text" dark> <v-icon small left>import_export</v-icon>Ricalcola </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex';
  import { bus } from '@/main';
  import Util from '@/util';
  import Security from '@/security';
  import FileEntity from './generale/FileEntity';
  import AssociazioneEntity from '@/pages/anagrafica/associazioni/AssociazioneEntity';
  import PartecipazioneEntity from './generale/PartecipazioneEntity';
  import TipologiaEntity from '../generale/TipologiaEntity';
  import FiltroClassifica from './generale/FiltroClassifica';

  export default {
    components: {},
    data() {
      return {
        Util,
        ruoli: Security.ruolo,
        elencoFunzioni: Security.enFunzione,
        formModes: Util.enFormMode,
        filtraStato: 'Tutti',
        filtraTesto: '',
        tipoClassifica: ['Outdoor', 'Indoor'],
        dialogExport: false,
        dialogCalcola: false,
        dialogClassifica: false,
        selected: [],
        prenotazioneDialog: false,
        classi: [
          {
            Descrizione: 'Master Maschile',
            Codice: 'MM',
          },
          {
            Descrizione: 'Master Femminile',
            Codice: 'MF',
          },
          {
            Descrizione: 'Scout Maschile',
            Codice: 'SM',
          },
          {
            Descrizione: 'Scout Femminile',
            Codice: 'SF',
          },
          {
            Descrizione: 'Lupetto Maschile',
            Codice: 'LM',
          },
          {
            Descrizione: 'Lupetto Femminile',
            Codice: 'LF',
          },
          {
            Descrizione: 'Prime Freccie',
            Codice: 'PF',
          },
        ],
        isMobile: false,
        filtroAnno: null,
        filtroClasse: null,
        filtroTipoGara: null,
        filtroSezione: null,
        filtroCategoria: null,
        filtroNumeroTessera: null,
        selezioneAnnoSportivo: null,
        selezioneTipo: 'Outdoor',
        filtroAnnoSportivo: new TipologiaEntity(),
        filtroTipo: 'Outdoor',
        headersIndoor: [
          {
            text: 'Classe',
            sortable: true,
            value: 'Classe',
            align: 'center',
            width: '50px',
          },
          {
            text: 'Categoria',
            sortable: true,
            value: 'categoriaCodice',
            align: 'center',
            width: '50px',
          },
          {
            text: 'Posizione',
            sortable: true,
            value: 'PosizioneRanking',
            align: 'center',
            width: '50px',
          },
          {
            text: 'Arciere',
            sortable: true,
            value: 'IscrittoDenominazione',
          },
          {
            text: 'Numero Pass',
            sortable: true,
            value: 'IscrittoNumeroTessera',
            align: 'center',
            width: '80px',
          },
          {
            text: 'Sodalizio Arciere',
            sortable: true,
            value: 'IscrittoAssociazione',
          },
          {
            text: 'Regione',
            sortable: true,
            value: 'sezioneDescrizione',
          },
          {
            text: 'Punteggio',
            sortable: true,
            value: 'PunteggioRanking',
            align: 'center',
            width: '80px',
          },
          {
            text: 'Spot',
            sortable: true,
            value: 'SpotRanking',
            align: 'center',
            width: '80px',
          },
          {
            text: '3DRound',
            sortable: false,
            value: '',
            align: 'center',
            width: '140px',
          },
          {
            text: 'Trophy',
            sortable: false,
            value: '',
            align: 'center',
            width: '140px',
          },
        ],
        headersOutdoor: [
          {
            text: 'Classe',
            sortable: true,
            value: 'Classe',
            align: 'center',
            width: '50px',
          },
          {
            text: 'Categoria',
            sortable: true,
            value: 'categoriaCodice',
            align: 'center',
            width: '50px',
          },
          {
            text: 'Posizione',
            sortable: true,
            value: 'PosizioneRanking',
            align: 'center',
            width: '50px',
          },
          {
            text: 'Arciere',
            sortable: true,
            value: 'IscrittoDenominazione',
          },
          {
            text: 'Numero Pass',
            sortable: true,
            value: 'IscrittoNumeroTessera',
            align: 'center',
            width: '80px',
          },
          {
            text: 'Sodalizio Arciere',
            sortable: true,
            value: 'IscrittoAssociazione',
          },
          {
            text: 'Regione',
            sortable: true,
            value: 'sezioneDescrizione',
          },
          {
            text: 'Punteggio',
            sortable: true,
            value: 'PunteggioRanking',
            align: 'center',
            width: '80px',
          },
          {
            text: 'Spot',
            sortable: true,
            value: 'SpotRanking',
            align: 'center',
            width: '80px',
          },
          {
            text: '40 Round',
            sortable: false,
            value: '',
            align: 'center',
            width: '140px',
          },
          {
            text: '60 Target',
            sortable: false,
            value: '',
            align: 'center',
            width: '140px',
          },
          {
            text: '44 Fusion',
            sortable: false,
            value: '',
            align: 'center',
            width: '140px',
          },
          {
            text: '60 Track',
            sortable: false,
            value: '',
            align: 'center',
            width: '140px',
          },
        ],
        pagination: {
          rowsPerPage: 10,
        },
        editedItem: {},
      };
    },
    computed: {
      ...mapGetters('eventiModule', ['getRankingGeneraleView']),
      ...mapGetters('sharedModule', ['getSezioni', 'getCategorieEvento', 'getCategorieEventoEuropeo', 'getAnniSportivi']),
      ...mapGetters(['isLogged', 'jwt']),
      ...mapGetters(['userData']),

      calculatedRow() {
        return this.$vuetify.breakpoint.name;
      },

      rankingGenerale() {
        return this.getRankingGeneraleView;
      },
      anniSportivi() {
        return this.getAnniSportivi;
      },
      tipiEvento() {
        return this.getTipiEvento;
      },
      categorie() {
        return this.getCategorieEvento.filter((p) => {
          return p.Codice != 'FO' && p.Codice != 'DI';
        });
      },
      categorieEuropeo() {
        return this.getCategorieEventoEuropeo;
      },
      sezioni() {
        return this.getSezioni;
      },
      pages() {
        if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
          return 0;
        }
        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
      },
      isAdmin() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN;
        } else {
          return false;
        }
      },
    },
    watch: {
      breakPoinSize() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.isMobile = true;
            break;
          case 'md':
          case 'lg':
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.isMobile = true;
            break;
          case 'md':
            this.isMobile = false;
            break;
          case 'lg':
            this.isMobile = false;
            break;
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
    },
    created() {
      const vm = this;
      vm.loadTipologie().then();
      if (vm.anniSportivi.length > 0) {
        vm.filtroAnnoSportivo = {
         id: 183,
        Codice: '20242025',
        Descrizione: '2024/2025',
        Tipo: 'AnnoSportivo',
        Tag: null,
        };
        vm.selezioneAnnoSportivo = {
         id: 183,
        Codice: '20242025',
        Descrizione: '2024/2025',
        Tipo: 'AnnoSportivo',
        Tag: null,
        };
      }
      this.refreshList();

      bus.$on('rankingRefresh', function (value) {
        vm.dialogCalcola = false;
        if (!value) {
          vm.refreshList();
        }
      });

      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.isMobile = true;
          break;
        case 'md':
        case 'lg':
        case 'xl':
          this.isMobile = false;
          break;
      }
    },
    methods: {
      ...mapActions('eventiModule', ['loadRankingGeneraleView', 'exportRankingGeneraleXLS', 'calcolaRanking']),
      ...mapActions('sharedModule', ['loadTipologie']),
      refreshList() {
        const vm = this;

        this.filtroAnnoSportivo = this.selezioneAnnoSportivo;
        this.filtroTipo = this.selezioneTipo;
        this.pagination.page = 1;
        vm.loadRankingGeneraleView(
          this.createFilter(
            this.filtroAnno,
            this.filtroClasse,
            this.filtroCategoria,
            this.filtroNumeroTessera,
            this.filtroTipoGara,
            this.filtroSezione,
            this.filtroAnnoSportivo,
            this.filtroTipo,
          ),
        );
      },

      dialogCalcolaOpen() {
        const vm = this;
        vm.dialogCalcola = true;
      },

      dialogExportOpen() {
        const vm = this;
        vm.dialogExport = true;
      },

      annullaFiltro() {
        const vm = this;
        vm.filtroClasse = null;
        vm.filtroCategoria = null;
        vm.filtroNumeroTessera = null;
        vm.filtroTipoGara = null;
        vm.filtroSezione = null;
        vm.selezioneAnnoSportivo = this.anniSportivi[0];
        vm.selezioneTipo = 'Outdoor';
        vm.refreshList();
      },

      // eslint-disable-next-line max-params
      createFilter(filtroAnno, filtroClasse, filtroCategoria, filtroNumeroTessera, filtroTipoGara, filtroSezione, filtroAnnoSportivo, filtroTipo) {
        let filtro = {
          anno: filtroAnno,
          numeroTessera: filtroNumeroTessera,
          tipoGara: null,
          classe: null,
          categoria: null,
          sezione: null,
          tipo: null,
        };
        if (filtroClasse) {
          filtro.classe = filtroClasse.Codice;
        }

        if (filtroTipoGara) {
          filtro.tipoGara = filtroTipoGara.Codice;
        }

        if (filtroCategoria) {
          filtro.categoria = filtroCategoria.Codice;
        }

        if (filtroSezione) {
          filtro.sezione = filtroSezione.Descrizione;
        }

        if (filtroAnnoSportivo) {
          filtro.annoSportivo = filtroAnnoSportivo.id;
          filtro.annoSportivoDesc = filtroAnnoSportivo.Descrizione;
        }
        if (filtroTipo) {
          filtro.tipo = filtroTipo;
        }
        return filtro;
      },

      getColorCategoria(codiceCategoria) {
        if (this.categorie) {
          const cat = this.categorie.filter((a) => {
            return a.Codice == codiceCategoria;
          });
          if (cat.length == 1) {
            return cat[0].Tag.split('|')[1];
          }
        }
      },

      getColorRanking(posizione) {
        let retVal = 'black';
        if (posizione == 1) {
          retVal = 'blue';
        }
        if (posizione == 2) {
          retVal = 'blue';
        }
        if (posizione == 3) {
          retVal = 'blue';
        }
        return retVal;
      },

      getColorClasse(classe) {
        let retVal = 'black';
        if (classe == 'LM' || classe == 'MM') {
          retVal = 'blue';
        }
        if (classe == 'LF' || classe == 'MF') {
          retVal = 'pink';
        }
        if (classe == 'PF') {
          retVal = 'red';
        }

        return retVal;
      },

      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      exportRankingGenerale() {
        const vm = this;
        vm.exportRankingGeneraleXLS(
          this.createFilter(
            this.filtroAnno,
            this.filtroClasse,
            this.filtroCategoria,
            this.filtroNumeroTessera,
            this.filtroTipoGara,
            this.filtroSezione,
            this.filtroAnnoSportivo,
            this.filtroTipo,
          ),
        );

        vm.dialogExport = false;
      },

      calcolaRankingGenerale() {
        const vm = this;
        vm.calcolaRanking(this.filtroAnnoSportivo);
        // vm.dialogCalcola = false;
      },

      formatDate(date) {
        if (date) {
          return new Date(date).toLocaleString().split(',')[0];
        }
      },
    },
  };
</script>

<style scoped>
  .mobile table.v-table tr:nth-child(odd) {
    border-left: 2px solid grey;
    border-top: 2px solid grey;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 2px solid green;
    border-top: 2px solid green;
  }

  table.v-table tbody td:first-child,
  table.v-table tbody td:not(:first-child),
  table.v-table tbody th:first-child,
  table.v-table tbody th:not(:first-child),
  table.v-table thead td:first-child,
  table.v-table thead td:not(:first-child),
  table.v-table thead th:first-child,
  table.v-table thead th:not(:first-child) {
    padding: 0px 5px !important;
  }
</style>
